import { create } from 'zustand';

/**
 * Global application store
 * Note: Most data fetching is now handled by React Query.
 * This store only manages authentication state and onboarding flow.
 */
export const useAppStore = create((set, get) => ({
  // Authentication
  accessKey: null,
  user: null,
  websiteUrl: null,
  isAuthenticated: false,
  isLoggingOut: false,
  isCheckingAuth: true,

  // Onboarding - Used by OnboardingPage for flow control
  onboardingStep: 'not_started', // 'not_started' | 'polling_profile' | 'completed' | 'failed'

  // Subscription - Cached for quick access
  subscription: null,

  // UI State
  loading: false,

  // Authentication Actions
  setAccessKey: (accessKey) => set({ accessKey, isAuthenticated: !!accessKey }),
  setUser: (user) => set({ user }),
  setWebsiteUrl: (websiteUrl) => set({ websiteUrl }),

  // Onboarding Actions
  setOnboardingStep: (step) => set({ onboardingStep: step }),

  // Subscription Actions
  setSubscription: (subscription) => set({ subscription }),

  // UI Actions
  setLoading: (loading) => set({ loading }),

  setIsLoggingOut: (isLoggingOut) => set({ isLoggingOut }),
  setIsCheckingAuth: (isCheckingAuth) => set({ isCheckingAuth }),
  // Reset - Clears all state (used on logout)
  reset: () =>
    set({
      accessKey: null,
      user: null,
      websiteUrl: null,
      isAuthenticated: false,
      onboardingStep: 'not_started',
      subscription: null,
      loading: false,
    }),
}));
